import { HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {UserService} from '../../services/user.service';
import {NewsletterService} from '../../services/newsletter.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import{ArticleService} from '../../services/article.service'

import {CommonService} from '../../services/common.service';



declare var $:any;



@Component({
  selector: 'home',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseComponent implements OnInit ,OnDestroy,IRule{

   homeSubscription :Subscription;

   url:any=AppSettings.API_ENDPOINT;

   categories:any=[];

   loader_img:boolean=false;

   loader_img_2:boolean=false;

   loader_img_3:boolean=false;

   role:any=[];

   msg:any;

   toastr:any;

   homeservice:any;

   latest_newsletters:any = [];

   latest_articles:any=[];

   category_articles:any=[];

   _router:any;

   userName:any;

   userId:any='';

   token:any='';

   navigationsType=[]

   articleCaregoryType = []

   searchTxt:any='';

   @HostBinding('style.width') public width: string = '100%';

   commonService:any;

   setting_category:any=[];

   filterChange:boolean =true;

   backCategory:any=[];

   notification:any=[];

   toltipName:Array<any>=[];
   toltipName1:Array<any>=[];
   
  
  



  constructor( private uSer:UserService,private cmmonService:CommonService, private newsletterService:NewsletterService, msg:MessageService, toastr: ToastrService,homeservice:HomeService , _router: Router,private articleService:ArticleService ){

    super(msg,toastr,homeservice,_router);

    this.msg = msg;
    this.toastr = toastr;
    this.homeservice = homeservice;
    this._router =_router;

    this.commonService = cmmonService;



    try{

      window.scrollTo(0, 0);

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        reqData:{'order':'updatedon desc' ,'page':'home'}
      }


      this.loader_img =true;

      this.loader_img_2 =true;

      this.loader_img_3 =true;

      this.newsletterService.newsletterData(data).subscribe( (response)=>{


        if(response.status=='success'){

          this.userName=response.user.name;
          this.userId= response.user.id;
          this.navigationsType=response.navigation;
          this.role =response.role;

          this.notification = response.notification;

          this.broadcast_menu();

          this.loader_img=false;
          this.latest_newsletters =  response.newsletter;

        } else{

          this._router.navigate(['/login']);

        }

      });

      


      this.articleService.getCategoryList({token:tokenA.token}).subscribe( (res) =>{

        if(res.status=='success'){

        this.categories = res.category;

        this.articleService.getCategoryType(data).subscribe( (res)=>{

          if(res.status=='success'){
  
            this.articleCaregoryType=res.type;
  
            this.setting_category = (res.setting.category !=null && res.setting.category !=undefined )? res.setting.category: [] ;


            this.articleService.articleData({token:tokenA.token,'page':'home'}).subscribe( (res) =>{
    
              if(res.status=='success'){
      
                this.loader_img_2=false;
                
      
                
                res.article.map(async (x)=>{
      
                  if(x.document.length>0){
                    x['documentType']=[]
        
                    x['toltipName']=[]
                    x.document.map((y)=>{
                      let name = y.split('/');
                      let toltip = name[2].split('_');
                      toltip.shift();
                      let arr=[]
        
                      toltip.map((y)=>{
                        arr.push(y)
                      })
        
                      x.toltipName.push(arr.join('_'))
                      x.documentType.push(y.split('.').slice(1))
                    })
                  }
                  
                  if(x.category){
                    let arr=[]
                    x.category.map((k)=>{
                      let typestr = this.categories.find( (item) =>{ return item.key == k;});
                      if(typestr!=undefined){
                        arr.push(k)
                      }
                    })
                    x.category = arr
                  }

                  if (x.thumbimage && x.thumbimage.includes("mitsubishi-motors")) {
                    //do nothing 
                  }else{
                    x.thumbimage = this.url + x.thumbimage;
                  }


                  if(x.document && x.document.length > 0){
                    x['attachmentNameGoTo'] = [];
                    x.document.map(async (val) => {
                      if(val.includes("mitsubishi-motors")){
                        try {

                          let token: any = JSON.parse(atob(localStorage.getItem('token')));
                          var data = new FormData();
                          data.append('upload[0][url]', val);

                          let obj = {
                            token: token,
                            reqData: data
                          }

                         await this.newsletterService.imageUpload(obj).subscribe((res) => {
                            if (res.status == 'success') {
                              var obj = {
                                'Name':decodeURIComponent(res.files[0].info['Content-Disposition']['filename']),
                                'Url':decodeURIComponent(res.files[0].url),
                                'Type':decodeURIComponent(res.files[0].info['Content-Disposition']['filename']).split('.').pop()
                              }
                              
                              x['attachmentNameGoTo'].push(obj);
                              
                              
                            }

                          })
                        }
                        catch (e) {
                          this.toastr.error('File upload failed!', '', { timeOut: 3000 });
                        }
                      }
                    })
                  }
                  this.latest_articles.push(x)
                })
                //this.latest_articles = res.article;

               
      
               
              }else{
                this._router.navigate(['/login']);
              }

              
      
            });

            this.articleService.articleData({token:tokenA.token,'page':'home','category':this.setting_category,group:'category'}).subscribe( (res) =>{
    
              if(res.status=='success'){
    
                this.loader_img_3=false;
    
               
                

    

                res.article.map((x)=>{
                  x.details.map((z)=>{
                     if(z.document.length>0){
                      if(z.document.length>0){
                        z['documentType']=[]
                        z['toltipName1']=[]
        
                        z.document.map((y)=>{
                          z.documentType.push(y.split('.').slice(1))
        
                          let name = y.split('/');
                          let toltip = name[2].split('_');
                          toltip.shift();
                          let arr=[]
        
                          toltip.map((y)=>{
                            arr.push(y)
                          })
        
                          z.toltipName1.push(arr.join('_'))
                        })
                      }
                      }
                      if(z.category){
                        let arr=[]
                        z.category.map((k)=>{
                          let typestr = this.categories.find( (item) =>{ return item.key == k;});
                          if(typestr!=undefined){
                            arr.push(k)
                          }
                        })
                        z.category = arr
                      }

                      if (z.image && z.image.includes("mitsubishi-motors")) {
                        //do nothing 
                      }else{
                        z.image = this.url + z.image;
                      }

                      if(z.document && z.document.length > 0){
                        z['attachmentNameGoTo'] = [];
                        z.document.map(async (val) => {
                          if(val.includes("mitsubishi-motors")){
                            try {
    
                              let token: any = JSON.parse(atob(localStorage.getItem('token')));
                              var data = new FormData();
                              data.append('upload[0][url]', val);
    
                              let obj = {
                                token: token,
                                reqData: data
                              }
    
                             await this.newsletterService.imageUpload(obj).subscribe((res) => {
                                if (res.status == 'success') {
                                  var obj = {
                                    'Name':decodeURIComponent(res.files[0].info['Content-Disposition']['filename']),
                                    'Url':decodeURIComponent(res.files[0].url),
                                    'Type':decodeURIComponent(res.files[0].info['Content-Disposition']['filename']).split('.').pop()
                                  }
                                  
                                  z['attachmentNameGoTo'].push(obj);
                                  
                                  
                                }
    
                              })
                            }
                            catch (e) {
                              this.toastr.error('File upload failed!', '', { timeOut: 3000 });
                            }
                          }
                        })
                      }
                    

                  })
                  debugger;
                  this.category_articles.push(x);
                })

    

                console.log("category_articles====",this.category_articles);
    
    
               this.categories.forEach( (element,i) =>{
    
                this.categories[i].selected =false;
    
    
    
                  if(this.setting_category!=null && this.setting_category!=undefined && this.setting_category.length > 0){
    
    
                    this.setting_category.forEach( (element2,j) =>{
    
    
                      if(element2 == element.key){
    
    
                        this.categories[i].selected =true;
    
    
                     }
    
    
                    });
    
    
    
                  }
    
    
    
    
              });
    
    
    
    
               }else{
                 this._router.navigate(['/login']);
               }
    
    
    
              });
    
              
  
          }else{
  
           // this.toastr.error('Category Type Not Found  !', '', {timeOut: 3000});
            this._router.navigate(['/login']);
          }
        });

       
        }

      });

      


    }catch(error){

     // this.toastr.error( error , '', {timeOut: 3000});
      this._router.navigate(['/login']);

    }




  }

  savePreferences(){



    let selectedCat =this.categories.filter(singleItem => singleItem.selected == true);



   let cat =[];

   selectedCat.forEach(element => {

     cat.push(element.key);

   });




    this.uSer.UserUpdate({'token':this.token,'reqData':{'id':this.userId,'category':cat,'page':'home'}}).subscribe( (evt)=>{

     //  console.log(evt);

       if(evt.status=='success'){

         this.toastr.success(' Categories saved ' , '', {timeOut: 3000});

       }

     });

     this.articleService.articleUpdate({'token':this.token,'reqData':{'group':'category','category':cat,'page':'home'}}).subscribe( (evt)=>{



       this.category_articles =evt.article ;
       
      
       this.category_articles.map((x)=>{

         x.details.map((z)=>{
            if(z.document.length>0){
               z['documentType']=[]
               z['toltipName1']=[]

               z.document.map((y)=>{
                 z.documentType.push(y.split('.').slice(1))

                 let name = y.split('/');
                 let toltip = name[2].split('_');
                 toltip.shift();
                 let arr=[]

                 toltip.map((y)=>{
                   arr.push(y)
                 })

                 z.toltipName1.push(arr.join('_'))
               })
             }
             if(z.category){
               let arr=[]
               z.category.map((k)=>{
                 let typestr = this.categories.find( (item) =>{ return item.key == k;});
                 if(typestr!=undefined){
                   arr.push(k)
                 }
               })
               z.category = arr
             }
         })

       })

    });






 $('#review-popup').modal('hide');



  }


  broadcast_menu(){

    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType,currentPage:'home'});

  }



  ngOnInit(){


  }


  ngOnDestroy(){

    if(this.homeSubscription){

      this.homeSubscription.unsubscribe();
      window.scrollTo(0, 0);


    }

  }

  get_title_type(type_str:string){

    let typestr = this.articleCaregoryType.find( (item) =>{ return item.key == type_str;});

     return (typestr!=undefined)?typestr.value:'';

  }

  get_category_type(type:string){

    let typestr = this.categories.find( (item) =>{ return item.key == type;});
    return (typestr!=undefined)?typestr.value:'';

  }

  trackAttachment(attach,article){
   
    let data={
      article:article.id,
      event:'download',
      source:'web',
      token:this.token
    }
    this.articleService.analytics(data).subscribe( (res)=>{

      if(res.status=='success' ){

      }
    })

    this.msg.sendMessage({type:'customeEvent',event:'attachment',value:attach,source:'home'});

  }

  trackCategory(category){
    this.msg.sendMessage({type:'customeEvent',event:'category',value:category,source:'home'});

  }


}
